import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

export interface DatatableAction<T = unknown> {
  label: string;
  icon: string;
  onClick: (row: T) => void;
}
export interface DatatableColumn<T> {
  columnDef: string;
  header: string;
  cell: (element: T) => string;
}
@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent<T> implements OnInit, OnChanges {
  @Input() dataSource: T[] = [];
  @Input() columnsToDisplay: DatatableColumn<T>[] = [];
  @Input() actions: DatatableAction<T>[] = [];

  matDataSource: MatTableDataSource<T> = new MatTableDataSource<T>([]);
  displayedColumns: string[] = [];

  ngOnInit(): void {
    this.matDataSource = new MatTableDataSource(this.dataSource);
    this.displayedColumns = [...this.columnsToDisplay.map(col => col.columnDef)];
    if (this.actions.length > 0) {
      this.displayedColumns.push('actions');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource'] && this.matDataSource) {
      this.matDataSource.data = this.dataSource;
    }
  }
}
